import React from 'react';
import {I18n} from 'react-redux-i18n';
import {func, node, bool} from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Icon from '@material-ui/core/Icon';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';

export default class DefaultConfirmationDialog extends React.PureComponent {
  static propTypes = {
    open: bool,
    title: node,
    message: node,
    onClose: func,
    onConfirm: func,
    hasIcon: bool,
    icon: node,
    classIcon: node,
    hasButton: bool,
    buttonDefaultNo: node,
    buttonDefaultYes: node,
    hasTextConfirm: bool,
    confirmText: node
  }

  state = {
    confirmEntered: false
  };

  handleConfirmTextChange = e => {
    const unlockWord = this.props.confirmText;
    this.setState({
      confirmEntered: e.target.value === unlockWord
    });
  };

  render() {
    let buttonDefaultNo = 'defaults.no';
    let buttonDefaultYes = 'defaults.yes';
    if (this.props.hasButton) {
      buttonDefaultNo = this.props.buttonDefaultNo;
      buttonDefaultYes = this.props.buttonDefaultYes;
    }
    return (
      <Dialog
        open={this.props.open}
      >
        <DialogTitle className="dialog-titledanger">
          {this.props.hasIcon && 
            <Icon className={this.props.classIcon}>{this.props.icon}</Icon>
          }
          {this.props.title}
        </DialogTitle>

        <DialogContent className="dialog-content">
          <DialogContentText>
            {this.props.message}
          </DialogContentText>
          {this.props.hasTextConfirm &&
          <Grid item lg={7} md={7} sm={7} xs={7}>
            <TextField
                id="name"
                label="Fill in the word CONFIRM here"
                margin="normal"
                className="dvrcard__unpairfield"
                fullWidth={true}
                onChange={this.handleConfirmTextChange}
              />
          </Grid>
          }
        </DialogContent>

        <DialogActions>
          <Button
            className="btn btn-secondary"
            onClick={this.props.onClose}
          >
            {I18n.t(buttonDefaultNo)}
          </Button>

          <Button
            className="btn btn-danger"
            onClick={this.props.onConfirm}
            disabled={this.props.hasTextConfirm && !this.state.confirmEntered}
          >
            {I18n.t(buttonDefaultYes)}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

}
